import { useElemDatasetBaseMixin } from './useElemDatasetBaseMixin';
import { ElemDatasetMixin } from './ElemDatasetMixin';

/**
 * Returns mixin for dataset widgets
 *
 * @param {string} [prop] dataset descriptor.props accessor name
 * @param [drilldown=false]
 * @param [deviations=false]
 * @param {import('../elem-utils').IDatasetPanelOptions|false} [panel={}]
 * @param {{methodName?: string}} [fetchEvent={methodName: 'loadData'}]
 * @return {ComponentOptions}
 */
export const useElemDatasetMixin = ({
    prop,
    drilldown = false,
    deviations = false,
    panel = { isMultiple: false },
    fetchEvent = { methodName: 'loadData' }
} = {}) => {
    const { mixins } = useElemDatasetBaseMixin({
        prop,
        panel,
        drilldown,
        deviations,
        fetchEvent
    });
    const [BaseMixin, ...RestMixins] = mixins;

    return {
        mixins: [BaseMixin, ElemDatasetMixin, ...RestMixins]
    };
};
